import React, { useState, useRef, useEffect, useMemo } from "react";
import { last, startCase, toLower } from "lodash";
import jsDig from "utils/jsDig";
import formatMetric from "utils/formatMetric";
import Pagination from "utils/Pagination";

export default function LiteBuyBoxTable(props) {

  let chevronDown = require("images/lite/icons/chevron-down.png");
  chevronDown = <img className="table-icon chevpdf" src={`/datapulse${chevronDown}`} />;
  let chevronUp = require("images/lite/icons/chevron-down.png");
  chevronUp = <img className="table-icon chevpdf" src={`/datapulse${chevronUp}`} style={{
    transform: 'rotate(180deg)'
  }} />;
  
  const amazonAds = () => (
    <svg className={isDarkMode ? "light-table-icon-svg" : "table-icon-svg"} width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path d="M38.6717 36.0421C38.517 36 38.3295 36.0234 38.1139 36.1031C35.2264 37.425 32.4186 38.3671 29.6904 38.925C23.7982 40.125 18.0561 39.4968 12.4686 37.0453C10.917 36.3609 8.76075 35.2078 5.99981 33.5765C5.92867 33.5204 5.84188 33.4876 5.75137 33.4828C5.65762 33.4781 5.57793 33.4875 5.50293 33.525C5.42793 33.5625 5.37168 33.6093 5.3295 33.6703C5.28731 33.7312 5.27793 33.8156 5.31075 33.9234C5.33887 34.0265 5.40918 34.1437 5.52637 34.2703C6.01387 34.8421 6.61856 35.4515 7.33575 36.0984C8.05293 36.7453 9.0045 37.4765 10.1904 38.2921C11.3764 39.1078 12.6186 39.8343 13.9076 40.4671C15.2014 41.1 16.7014 41.6343 18.4123 42.0656C20.1232 42.4968 21.8342 42.7125 23.5404 42.7125C25.2373 42.7125 26.8873 42.539 28.4858 42.2015C30.0889 41.8593 31.4389 41.4562 32.5404 40.9875C33.6373 40.5234 34.6498 40.0031 35.5779 39.4406C36.5061 38.8781 37.1904 38.4 37.6357 38.0203C38.0811 37.6359 38.3998 37.3359 38.5826 37.1109C38.7982 36.8437 38.9061 36.614 38.9061 36.4125C38.9107 36.2015 38.8264 36.0796 38.6717 36.0421ZM24.7217 16.3171C24.0092 16.3781 23.1514 16.5093 22.1436 16.7062C21.1357 16.8984 20.2029 17.1421 19.3404 17.4281C18.4779 17.714 17.5967 18.1125 16.7014 18.6187C15.8014 19.125 15.0373 19.7062 14.4045 20.3531C13.7717 21 13.2561 21.8109 12.8529 22.7906C12.4498 23.7656 12.2482 24.839 12.2482 26.0109C12.2482 27.2812 12.4686 28.4109 12.9186 29.4093C13.3639 30.4078 13.9592 31.1906 14.7092 31.7718C15.4545 32.3531 16.3029 32.8078 17.2404 33.1406C18.1779 33.4734 19.1717 33.6234 20.2029 33.5812C21.2342 33.539 22.242 33.3796 23.2217 33.0984C24.1967 32.8218 25.1154 32.3765 25.9686 31.7718C26.8217 31.1671 27.5201 30.45 28.0686 29.6296C28.2701 29.939 28.4482 30.1687 28.6076 30.3187L29.0154 30.7359C29.2873 31.0125 29.7045 31.4203 30.267 31.9593C30.8248 32.4984 31.3967 33.0234 31.9686 33.539L36.8623 28.8562L36.5811 28.6265C36.3795 28.4718 36.1404 28.2515 35.8686 27.9562C35.5967 27.6656 35.3248 27.3421 35.0623 26.9953C34.7951 26.6484 34.5654 26.2406 34.3732 25.7812C34.1811 25.3218 34.0826 24.8765 34.0826 24.4453V12.1265C34.0826 11.6531 33.9936 11.1421 33.8154 10.589C33.6326 10.0406 33.3139 9.44058 32.8451 8.7937C32.3764 8.14683 31.7951 7.56558 31.1014 7.05933C30.4029 6.55308 29.4748 6.12183 28.3076 5.77495C27.1451 5.42808 25.842 5.25464 24.4076 5.25464C22.9404 5.25464 21.5764 5.42808 20.3014 5.76558C19.0311 6.10776 17.9436 6.56245 17.0342 7.13433C16.1295 7.7062 15.3514 8.36714 14.7045 9.12183C14.0576 9.87651 13.5748 10.664 13.2607 11.4843C12.9467 12.3046 12.7873 13.1343 12.7873 13.9734L19.1248 14.5312C19.3826 13.7625 19.7295 13.0968 20.1561 12.525C20.5873 11.9531 20.9951 11.5406 21.3654 11.2828C21.7404 11.025 22.1436 10.8187 22.5701 10.664C23.0014 10.5093 23.292 10.4296 23.442 10.4109C23.592 10.3968 23.7092 10.3921 23.7983 10.3921C25.0498 10.3921 25.917 10.7625 26.4045 11.4984C26.7092 11.9437 26.8592 12.6187 26.8592 13.5281V16.1812C26.1467 16.2093 25.4342 16.2562 24.7217 16.3171ZM26.8639 23.4375C26.8639 24.2156 26.7607 24.9234 26.5592 25.5468C26.1279 26.9109 25.3076 27.7687 24.1029 28.1156C23.0529 28.4249 22.0545 28.2703 21.1076 27.6562C20.0998 27 19.5982 26.0718 19.5982 24.8765C19.5982 23.9437 19.8326 23.1468 20.3014 22.4812C20.7701 21.8203 21.3936 21.3234 22.1764 20.9953C22.9592 20.6671 23.7232 20.4328 24.4732 20.2968C25.2186 20.1562 26.0201 20.0718 26.8639 20.0437V23.4375ZM42.5764 33.6984C42.3748 33.4453 41.8311 33.2812 40.9404 33.1968C40.0498 33.1125 39.2764 33.1171 38.6107 33.2156C37.8936 33.3 37.1529 33.5062 36.3936 33.8437C35.6295 34.1765 35.2967 34.4578 35.3811 34.6781L35.4139 34.739L35.4561 34.7718L35.5217 34.7812H35.7373C35.7748 34.7812 35.8217 34.7765 35.8873 34.7718C35.9529 34.7671 36.0139 34.7578 36.0701 34.7531C36.1264 34.7484 36.2061 34.739 36.3092 34.7343C36.4076 34.7296 36.5014 34.7156 36.5904 34.7015C36.6045 34.7015 36.7639 34.6875 37.0732 34.6593C37.3826 34.6312 37.6076 34.6125 37.7436 34.5984C37.8795 34.5843 38.1092 34.5703 38.4232 34.5562C38.7373 34.5421 38.9904 34.5421 39.1779 34.5562C39.3654 34.5703 39.5764 34.589 39.8154 34.6078C40.0545 34.6265 40.2467 34.6687 40.3967 34.7343C40.5467 34.7953 40.6592 34.875 40.7295 34.9734C40.9733 35.2828 40.9264 35.9671 40.5889 37.0312C40.2514 38.0953 39.9326 38.9437 39.6326 39.5718C39.5014 39.839 39.5014 40.0031 39.6326 40.0734C39.7639 40.1437 39.9467 40.0781 40.1904 39.8859C40.9217 39.314 41.5311 38.4515 42.0233 37.2937C42.3092 36.6093 42.5154 35.8968 42.6373 35.1515C42.7498 34.4062 42.7311 33.9234 42.5764 33.6984Z"/>
    </svg>
  );

  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(props.groups && props.groups.length > 0 ? props.groups[0] : null);
  const [isCollapsed, setIsCollapsed] = useState(props.collapsed || false);
  const dropdownRef = useRef(null);
  const tableContainerRef = useRef(null);
  const collapsible = props.collapsed == true || props.collapsed == false ? true : false;

  // Pagination state
  const itemsPerPage = 20;
  const [currentPage, setCurrentPage] = useState(1);

  // filter out any dimensions where buy_box_percentage >= 95
  const filteredData = props.dimensions.filter(dim => {
    return jsDig(["yesterday", dim, "buy_box_percentage"], props.data) < 95;
  });
  const currentTableData = useMemo(() => {
    // Apply pagination to the filtered data
    const firstPageIndex = (currentPage - 1) * itemsPerPage;
    const lastPageIndex = firstPageIndex + itemsPerPage;
    return filteredData.slice(firstPageIndex, lastPageIndex); // Return only the rows for the current page
  }, [currentPage, props.dimensions, props.data]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  
  useEffect(() => {
    // Adjust max-height based on the collapsed state and the content of the table
    const maxHeight = isCollapsed ? "0px" : `${tableContainerRef.current.scrollHeight}px`;
    tableContainerRef.current.style.maxHeight = maxHeight;
  }, [isCollapsed]);
  
  const toggleCollapse = () => setIsCollapsed(!isCollapsed);
  const toggleDropdown = () => setShowDropdown(!showDropdown);
  const selectGroup = (group) => {
    setSelectedGroup(group);
    setShowDropdown(false);
  };

  const baseUrl = props.baseUrl ? props.baseUrl.replace(/\/$/, "") : null;

  const renderGroupSelector = () => {
    if (!props.groups || props.groups.length === 0) {
      return null;
    }

    return (
      <div ref={dropdownRef} style={{ position: 'relative', display: 'inline-block', width: "170px" }}>
        <button onClick={toggleDropdown} style={{ color: 'white', backgroundColor: 'transparent', fontSize: '16px', cursor: 'pointer', display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", border: "none" }}>
          <span className="title-color-primary">{selectedGroup || 'Select Group'}</span>
          {!showDropdown ? <>{chevronDown}</> : <>{chevronUp}</>}
        </button>
        {showDropdown && (
          <div className="metric-table-group-selector" style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            zIndex: 1
          }}>
            {props.groups.map((group) => (
              <div key={group} style={{ padding: '8px 12px', cursor: 'pointer', textAlign: 'left' }} onClick={() => selectGroup(group)}>
                {group}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderTopSummaryRow = () => {
    if (props.topSummaryRow) {
      const dim = jsDig(["dimension"], props.topSummaryRow);
      const topSummaryData = jsDig(["data"], props.topSummaryRow);
      return (
        <>
          <tr className="top-summary-row">
            <th className="dimension-column amazon-bb lite-table-cell ">{dim}</th>
            {props.headerOrder.map((metric, index) => {
              const metricName = toLower(metric);
              const metricValue = selectedGroup ? jsDig([toLower(selectedGroup), metricName, "total"], topSummaryData) : jsDig([metricName, "total"], topSummaryData);
              return (
                <React.Fragment key={index}>
                  {metricValue ? 
                    formatCells(metricValue, metricName, false, false, false) : 
                    renderBlankRow(false)
                  }
                </React.Fragment>
              );
            })}
          </tr>
        </>
      )
    } 
  }

  const renderTableHeader = () => {
    let columnWidth = 100 / (props.headerOrder.length + 1);
      columnWidth = 23
    return (
      <>
        <tr className="table-header">
        <th style={{paddingTop: "25px"}}className={`lite-border-right`}>Product Name / Link</th>
          {props.headerOrder.map((metric, index) => {
            const last = props.headerOrder.length - 1 == index ? true : false
            return <th key={index} className={`${last == true ? "" : "lite-border-right"} lite-border-bottom`} colSpan={props.subHeaderOrder.length} style={{width: `${columnWidth}%`}}>{getColumnName(metric)}</th>;
          })}
        </tr>
        <tr className="table-header sh">
          <th className="first-th  lite-border-right lite-border-bottom"></th>
          {props.headerOrder.map((metric, index) => {
            const last = props.headerOrder.length - 1 == index ? true : false
            return props.subHeaderOrder.map((subHeader, index) => {
              if (subHeader == "buy_box_percentage") {subHeader = "Buy Box %"}
              if (metric == "yesterday" && subHeader == "revenue") {subHeader = "Revenue"}
              if (metric == "last_30" && subHeader == "revenue") {subHeader = "Avg. Daily Rev."}

              return <th className={`lite-border-bottom ${subHeader == "Y/Y" && last == false ? "lite-border-right yoy" : subHeader}-cell subheader-cell`} key={`${subHeader}-${index}`}>{subHeader}</th>;
            })
          })}
        </tr>
      </>
    )
  };

  const renderTableRows = () => {
    return currentTableData.map((dim) => {
      const borderClass = dim.toLowerCase() === "ytd" ? "lite-border-top" : false;
      // Get the name of the current month
      const monthName = new Date().toLocaleString('en', { month: 'long' });
      let showProjection = false;
      if (dim.toLowerCase() == monthName.toLowerCase()) { showProjection = true; }
      if (dim.toLowerCase() == "ytd") { showProjection = true; }
      if (dim.toLowerCase() == "total") { showProjection = true; }
      return (
        jsDig(["yesterday", dim, "buy_box_percentage"], props.data) >= 95 ? null :
        <tr className="regular-row" key={dim}>
          <th className={`dimension-column amazon-bb lite-table-cell  lite-border-right ${borderClass ? borderClass : ""}`}>
            {dim}
            {(props.containsUrl && baseUrl && (dim != "(not set)")) && (
              <a href={`${baseUrl}${dim}`} target="_blank" rel="noreferrer" style={{marginLeft: "8px"}}>
                <i className="fas fa-external-link-alt"></i>
              </a>
            )}
              <a href={`https://www.amazon.com/dp/${jsDig(["last_30", dim, "asin"],props.data)}`} target="_blank" rel="noreferrer" style={{marginLeft: "8px"}}>
              <i className="fas fa-external-link-alt"></i>
            </a>
          </th>
          {props.headerOrder.map((metric, index) => {
            const metricName = toLower(metric);
            const metricValue = selectedGroup ? jsDig([toLower(selectedGroup), metricName, dim], props.data) : jsDig([metricName, dim], props.data);
            const last = props.headerOrder.length - 1 == index ? true : false
            return (
              <React.Fragment key={index}>
                {metricValue ? 
                  formatCells(metricValue, metricName, borderClass, last, showProjection, dim) : 
                  renderBlankRow(borderClass)
                }
              </React.Fragment>
            );
          })}
        </tr>
      );
    })
  };

  const renderBlankRow = (borderClass) => {
    return (
      <>
        {
          props.subHeaderOrder.map((subHeader, index) => {
            return (
              <td className={`${borderClass ? borderClass : ""} ${index == 0 ? "" : ""} ${index == props.subHeaderOrder.length - 1 && last == false ? "lite-border-right" : ""}`} key={index}>
                <div className="lite-table-cell">&nbsp;</div>
              </td>
            )
          })
        }
      </>
    )
  }

  // Helper function to format individual metric
  const formatCells = (metric, metricName, borderClass, last, showProjection, dim) => {
    return (
      <>
        {props.subHeaderOrder.map((subHeader, index) => {
          const thisYear = new Date().getFullYear() - 1
          const lastYear = thisYear - 1;
          let metricValue = null;
          if (subHeader == lastYear) {
            metricValue = metric["previous"];
          } else if (subHeader == thisYear) {
            if (showProjection) {
              metricValue = metric["current"];
            } else {
              metricValue = metric["current"];
            }
          } else if (subHeader == "Diff") {
            metricValue = metric["difference"];
          } else if (subHeader == "Y/Y") {
            if (showProjection) {
              metricValue = metric["comparison"];
            } else {
              metricValue = metric["comparison"];
            }
          } else if (subHeader == "revenue") {
            metricValue = metric["revenue"]
          }
          else if (subHeader == "buy_box_percentage") {
            metricValue = metric["buy_box_percentage"]
          } else {
            metricValue = metric; // If the subheader doesn't match any expected values, assume it's a flat dataset with no groupings
          }
          return (
            <td className={`${borderClass ? borderClass : ""} ${subHeader == thisYear && showProjection == true && dim != "YTD" ? "project-true" : ""} ${index == props.subHeaderOrder.length - 1 && last == false ? "lite-border-right" : ""}`} key={index}>
              <div className="lite-table-cell">
                {formatMetric(metricName, metricValue, subHeader, true)}
              </div>
            </td>
          )
        })}
      </>
    )
  };

  const getColumnName = (metric) => {
    switch (metric) {
      case "spend":
        return "Spend";
      case "clicks":
        return "Clicks";
      case "conversions":
        return "Conversions";
      case "revenue":
        return "Revenue";
      case "roas":
        return "ROAS";
      case "cpa":
        return "CPA";
      case "mer":
        return "MER";
      case "frequency":
        return "Frequency";
      case "conversion_rate":
        return "Conversion Rate";
      case "sessions":
        return "Sessions";
      case "paid_sessions":
        return "Paid Sessions";
      case "organic_sessions":
        return "Organic Sessions";
      case "impressions":
        return "Impressions";
      case "reach":
        return "Reach";
      case "new_customers":
        return "New Customers";
      case "aov":
        return "AOV";
      case "open_rate":
        return "Open Rate";
      case "ctr":
        return "CTR";
      case "bounce_rate":
        return "Bounce Rate";
      case "email_list_growth":
        return "Email List Growth";
      case "affiliates":
        return "Affiliate";
      case "direct":
        return "Direct";
      case "referral":
        return "Referral";
      case "audio":
        return "Audio";
      case "mobile_push_notifications":
        return "Mobile Push Notifications";
      case "sms":
        return "SMS";
       case "last_30":
        return "Last 30 Days";
      default:
        return startCase(metric);
    }
  }

  const renderTableName = (tableName, selectedGroup = "") => {
    if (selectedGroup != "") {
      selectedGroup = "- " + selectedGroup
    }
    let tableIcon = ""
    if (tableName.toLowerCase().includes("search")) {
      if (selectedGroup.toLowerCase().includes("google ads")) {
        tableIcon = googleAds
      } else if (selectedGroup.toLowerCase().includes("microsoft ads")) {
        tableIcon = microsoftAds
      }
      else tableIcon = searchIcon
    } else if (tableName.toLowerCase().includes("social")) {
      if (selectedGroup.toLowerCase().includes("facebook")) {
        tableIcon = facebook
      } else if (selectedGroup.toLowerCase().includes("tiktok")) {
        tableIcon = tiktokAds
      }
      else tableIcon = socialIcon
    } else if (tableName.toLowerCase().includes("facebook") && tableName.toLowerCase().includes("instagram")) {
      tableIcon = metaAds
    } else if (tableName.toLowerCase().includes("tiktok")) {
      tableIcon = tiktokAds
    } else if (tableName.toLowerCase().includes("youtube")) {
      tableIcon = youtube
    } else if (tableName.toLowerCase().includes("pinterest")) {
      tableIcon = pinterest
    } else if (tableName.toLowerCase().includes("amazon")) {
      tableIcon = amazon
    }

    else tableIcon = ""
    return(
    <div className="lite-flexbox justify-content-center">
      <div className="">
        {tableIcon}
      </div>
      <div className="table-name">
        {tableName} {selectedGroup}
      </div>
    </div>
    )
  }

  const exportTableToCSV = () => {
    const rows = [];
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;

    // Headers
    const headers = ['Dimension'];
    const subHeaders = [''];
    
    props.headerOrder.forEach((header) => {
        headers.push(getColumnName(header));
        headers.push(''); // Empty space for the subheader row
        headers.push('');
    });

    props.headerOrder.forEach((header) => {
        subHeaders.push(previousYear);
        subHeaders.push(currentYear);
        subHeaders.push('Y/Y');
    });

    rows.push(headers.join(','));
    rows.push(subHeaders.join(','));

    // Data Rows
    props.dimensions.forEach((dim) => {
        const row = [dim]; // First column is the dimension name
        
        props.headerOrder.forEach((metric) => {
            const metricName = toLower(metric);
            const metricData = selectedGroup
                ? jsDig([toLower(selectedGroup), metricName, dim], props.data)
                : jsDig([metricName, dim], props.data);
                
            // Handling each subheader value
            let currentValue = '';
            let previousValue = '';
            let yoyValue = '';

            if (metricData) {
                previousValue = metricData['previous'] !== undefined ? formatMetric(metricName, metricData['previous'], previousYear) : '';
                currentValue = metricData['current'] !== undefined ? formatMetric(metricName, metricData['current'], currentYear) : '';
                yoyValue = metricData['comparison'] !== undefined ? formatMetric(metricName, metricData['comparison'], 'Y/Y') : '';
            }

            // Ensure proper formatting by enclosing values in quotes if they contain commas or special characters
            row.push(`"${previousValue}"`);
            row.push(`"${currentValue}"`);
            row.push(`"${yoyValue}"`);
        });

        rows.push(row.join(','));
    });

    // Create and download the CSV file
    const csvContent = "data:text/csv;charset=utf-8," + rows.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${props.tableName || 'table_data'}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

  return (
    <>
      <div className="metric-table-container" style={props.disabledMsg ? {opacity: "0.5"} : null}>
        {/* Export Button */}
        {/* <button onClick={exportTableToCSV}>Export to CSV</button> */}
        
        <div className={`table-title lite-flexbox justify-content-space-between ${collapsible && 'collapsible'}`}>
          <div className="table-title-left">{renderGroupSelector()}</div>
          <div className={`table-title-center ${isCollapsed && 'collapsed'} ${collapsible && 'collapsible'}`} onClick={collapsible ? toggleCollapse : undefined}>{renderTableName(props.tableName, selectedGroup ? selectedGroup : "")}</div>
          <div className={`table-title-right ${isCollapsed && 'collapsed'} ${collapsible && 'collapsible'}`} onClick={collapsible ? toggleCollapse : undefined}>
            <div className={collapsible ? "" : "d-none"}>
              {isCollapsed ? chevronUp : chevronDown}
            </div>
          </div>
        </div>
        <div className="lite-table-container" ref={tableContainerRef} style={{
          overflow: 'hidden',
          transition: 'max-height 0.5s ease',
          maxHeight: isCollapsed ? '0px' : '1700px'
        }}>
          <table>
            <thead>
              {renderTableHeader()}
            </thead>
            <tbody>
              {renderTopSummaryRow()}
              {renderTableRows()}
            </tbody>
          </table>
        </div>
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={filteredData.length}
          pageSize={itemsPerPage}
          onPageChange={handlePageChange}
        />

      </div>
      {props.disabledMsg && (
        <div className="coming-soon-container">
          {props.disabledMsg}
        </div>
      )}
    </>
  );
}
